import { __decorate } from "tslib";
import { Component, Mixins, Vue } from 'vue-property-decorator';
import { AlertType } from '~/nasa_ui/types';
import AutoStopListeningMixin from '~/nasa_ui/mixins/AutoStopListeningMixin';
let BaseVue = class BaseVue extends Mixins(Vue, AutoStopListeningMixin) {
    AlertType = AlertType;
    hasSlot(name = 'default') {
        return !!this.$slots[name] || !!this.$scopedSlots[name];
    }
};
BaseVue = __decorate([
    Component
], BaseVue);
export default BaseVue;
